import React, { useState, useEffect } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Space, Checkbox, Row, Col } from "antd";

const defaultData = [
  { label: "Apple", value: "Apple" },
  { label: "Pear", value: "Pear" },
  { label: "Orange", value: "Orange" },
];

const EnumFIlter = (item, search, options = defaultData) => {
  const Filter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const [checkedValues, setCheckedValues] = useState([]);
    useEffect(() => {
      setCheckedValues(selectedKeys);
    }, [selectedKeys]);

    const handleSearch = () => {
      setSelectedKeys(checkedValues);
      let enumTextAry = [];
      options.forEach(v => {
        checkedValues.forEach(vs => {
          if (v.value === vs) {
            enumTextAry.push(v.label)
          }
        })
      })

      search({
        column_text: item.title,
        column_name: item.dataIndex,
        values: checkedValues,
        column_type: 4,
        enumTextAry,
        type: 'enum'
      })
      confirm();
    };
    const handleReset = (clearFilters) => {
      clearFilters();
    };
    return (
      <div
        style={{
          padding: 8,
        }}
      // onKeyDown={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "16px" }}>
          <Checkbox.Group
            value={checkedValues}
            onChange={(value) => {
              setCheckedValues(value);
            }}
          >
            <Row gutter={[0, 10]}>
              {options.map((item) => (
                <Col span={24} key={item.value}>
                  <Checkbox key={item.value} value={item.value}>
                    {item.label}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch()}
            icon={<SearchOutlined />}
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <span style={{ visibility: "hidden" }}>-</span>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            style={{
              width: 90,
            }}
          >
            清空
          </Button>
        </Space>
      </div>
    );
  };

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys = [],
      confirm,
      clearFilters,
    }) => (
      <Filter
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
export default EnumFIlter;
